import { get, mapValues, trim, isString } from 'lodash';

const normalize = value => (isString(value) ? trim(value) : value);
export const getFieldValues = form => mapValues(form, field => normalize(get(field, 'value')));
export const getFieldInitialValues = form => mapValues(form, field => normalize(get(field, 'initialValue')));
